import React from 'react';
import ImageUploadComponent from '../pages/Image';

const Home = () => {
  const country = [{
    value: "1", label: "India"
  }, {
    value: "2", label: "Japan"
  }, {
    value: "3", label: "China",
  }];

  const city = [{
    value: "1", label: "azamgarh", country_id: "1"}, {
    value: "2", label: "noida", country_id: "1"
  }, {
    value: "3", label: "GBN", country_id: "2"
  }, {
    value: "4", label: "Badau", country_id: "3"
  }, {
    value: "5", label: "Kanpur", country_id: "2"
  }, { value: "6", label: "GNoida", country_id: "1"
}]

return <>
  <h1>City</h1>
  {/* <ImageUploadComponent/> */}
    
</>;
};

export default Home;